import React from "react";
import cn from "classnames";
import styles from "./NotificationBadge.module.sass";

const NotificationBadge = ({ count, className, dot = false, large = false }) => {
    if (!count && !dot) return null;
    
    const displayCount = count > 99 ? "99+" : count;
    
    return (
        <span 
            className={cn(
                styles.badge, 
                className,
                { 
                    [styles.dot]: dot,
                    [styles.large]: large 
                }
            )}
        >
            {!dot && displayCount}
        </span>
    );
};

export default NotificationBadge;
